import { devtools } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

import baseConfig from '@/config';
import { IStoreItem } from '@/utils/Uploader/type';

interface IUploaderInfo {
  [propname: string]: {
    [propname: string]: IStoreItem;
  };
}

export interface UploaderStoreType {
  uploaderInfo: IUploaderInfo;
  setUploaderInfo: (info: IUploaderInfo) => void;
}

export const UploaderStore = createWithEqualityFn<UploaderStoreType>()(
  devtools(
    (set, get) => ({
      uploaderInfo: {},
      setUploaderInfo: (info: IUploaderInfo) => {
        set({ uploaderInfo: info });
      },
    }),
    {
      name: 'uploader_store',
      enabled: baseConfig.debuggable,
    },
  ),
);
